import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const RedeemGrid = styled.div`
  width:100%;
  display:grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap:40px;

  ${mq(Devices.mobile)} {
    grid-template-columns: 1fr;
    gap:20px;
    padding:0 10px 20px 10px;
  }
`;

export const RedeemContainer = styled.div<{gapOff?:boolean, span?:Number}>`
    position: relative;
    width:100%;
    height:83vh;
    overflow-y: auto;
    display:flex;
    flex-direction: column;
    gap: ${props => props.gapOff?"unset":"10px"};
    ${props => props.span?"grid-column: span " + props.span + ";":""};

    ${mq(Devices.mobile)} {
      height:auto;
      grid-column: unset;
      ${props => props.span?"grid-row-start: 0":"unset"};
      ${props => props.span?"grid-row-end: 1":"unset"};
    }
`;

export const FlexInput = styled.div`
    width:100%;
    display:flex;
    gap:10px;
`;

export const Popup = styled.div<{show?:boolean}>`
    position: fixed;
    background:#ffffff45;
    top:0;
    left:0;
    width:100%;
    height:100%;
    z-index:1200;
    display:${props => props.show?"flex":"none"};
    align-items: center;
    justify-content: center;
`;

export const PopupBox = styled.div`
    position: relative;
    max-width:320px;
    width:100%;
    min-height:150px;
    background:#fff;
    border-radius: 5px;
    padding:50px 20px 20px 20px;
    overflow:hidden;
    box-shadow: 0 0 3px 1px rgba(0,0,0,0.3);

    p{
      font-size: 16px;
    }

    div:nth-of-type(2){
      display:flex;
      width:100%;
      gap:20px;
      margin-top: 30px;
      
      button{
        width:100%;
        background:#2A848E;
        color:#fff;
        border-radius:5px;
        font-size: 16px;
        font-weight: 500;
        padding:8px 0;
      }
    }
    
`;

export const BoxTop = styled.div`
  position: absolute;
  top:0;
  left:0;
  width:100%;
  height:34px;
  background:#2A848E;
  display: flex;
  align-items: center;  
    
  span {
    color: #fff;
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
  }
  
  button{
    width:16px;
    color:#fff;
    margin-left: auto;
    margin-right: 10px;
    margin-top: 4px;
    path{
      fill:#fff;
    }
  }
`;